import { motion } from "framer-motion";
import { ShieldCheck, Sun, Droplets, HeartHandshake } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { copy } from "../data/copy";

const TILES = [
    { icon: HeartHandshake, bg: "var(--kp-terracotta)", text: "var(--kp-cream)" },
    { icon: Sun, bg: "var(--kp-turmeric)", text: "var(--kp-ink)" },
    { icon: Droplets, bg: "var(--kp-banana)", text: "var(--kp-cream)" },
    { icon: ShieldCheck, bg: "var(--kp-mustard)", text: "var(--kp-cream)" },
];

export const TrustBadges = () => {
    const { t, lang } = useLang();
    return (
        <section
            className="py-16 md:py-24 bg-[color:var(--kp-cream-2)]"
            data-testid="trust-badges"
        >
            <div className="max-w-[1300px] mx-auto px-6 md:px-10">
                <div className="text-center mb-12">
                    <div className="eyebrow mb-4 justify-center inline-flex">
                        {t(copy.trust.eyebrow)}
                    </div>
                    <h2 className={`text-4xl md:text-5xl font-bold ${lang === "te" ? "font-telugu-display" : "font-display"}`}>
                        {t({ en: "Small kitchen,", te: "చిన్న వంటగది," })}{" "}
                        <em className="italic text-[color:var(--kp-terracotta)] font-medium">
                            {t({ en: "big promises.", te: "పెద్ద మాటలు." })}
                        </em>
                    </h2>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
                    {copy.trust.items.map((it, i) => {
                        const cfg = TILES[i % TILES.length];
                        const Icon = cfg.icon;
                        return (
                            <motion.div
                                key={i}
                                initial={{ opacity: 0, y: 20, scale: 0.95 }}
                                whileInView={{ opacity: 1, y: 0, scale: 1 }}
                                viewport={{ once: true, margin: "-40px" }}
                                transition={{ duration: 0.7, delay: i * 0.08, ease: [0.19, 1, 0.22, 1] }}
                                className="card-warm p-6 md:p-7 flex flex-col items-start"
                                style={{ background: cfg.bg, color: cfg.text }}
                                data-testid={`trust-item-${i}`}
                            >
                                <div
                                    className="w-12 h-12 rounded-full flex items-center justify-center mb-4"
                                    style={{ background: "rgba(255,255,255,0.18)" }}
                                >
                                    <Icon size={22} strokeWidth={2} />
                                </div>
                                <h3 className={`text-xl md:text-2xl font-bold mb-2 leading-tight ${
                                    lang === "te" ? "font-telugu-display" : "font-display"
                                }`}>
                                    {t(it.title)}
                                </h3>
                                <p className={`text-sm opacity-90 ${lang === "te" ? "font-telugu-body" : "font-body"}`}>
                                    {t(it.body)}
                                </p>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
